// extracted by mini-css-extract-plugin
module.exports = {"IconCta":"styles_IconCta__EYiCe","disabled":"styles_disabled__WLFzd","loading":"styles_loading__8LIwR","icon":"styles_icon___2vNv","spinner":"styles_spinner__b_pYu"};